import { postRequest } from "@react/helpers/fetch"

export const createDownPayment = (projectId, body) =>
  postRequest({
    url:  `/projects/${projectId}/down_payment.json`,
    body: body,
  })
